exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-no-results {\n  display: block;\n}\nfi-no-results .no-results {\n  min-height: 300px;\n}\nfi-no-results .no-results > div {\n  text-align: center;\n}\nfi-no-results .no-results > div md-icon {\n  color: #ddd;\n  font-size: 36px;\n  height: 36px;\n  width: 36px;\n  line-height: 36px;\n  min-width: 36px;\n  min-width: 36px;\n  user-select: none;\n}\nfi-no-results .no-results > div h6 {\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 10px;\n  margin-bottom: 0;\n}", ""]);

// exports
